<app-loader></app-loader>
<div class="my-games-page">
  <!-- Header -->
  <div class="my-games-header">
    <div>
      <h1 class="page-title text-2xl md:text-3xl font-black text-white tracking-tight uppercase italic">MY <span
          class="title-accent">GAMES</span></h1>
      <p class="page-subtitle">Games you have an account for</p>
    </div>
    <div class="search-box">
      <i class="fas fa-search search-icon"></i>
      <input type="text" placeholder="Search game..." [(ngModel)]="searchTerm" class="search-input" />
    </div>
  </div>

  <!-- Grid of Game Accounts -->
  <div *ngIf="viewMode == 'grid'">
    <div #accountGrid (scroll)="onGridViewScroll()" class="games-grid"
      *ngIf="filteredAccounts().length > 0; else noRecord">
      <app-game-card
        *ngFor="let account of filteredAccounts()"
        [game]="resolveGame(account.GameName)"
        statusLabel="ACTIVE"
        [statusActive]="true"
        [rotate]="true"
        (cardClick)="redirectionToCredentials(account)"
      ></app-game-card>
    </div>
  </div>

  <!-- Pagination -->
  <!-- <div class="row">F
      <div class="mbp_pagination mt-6 text-center">
        <ul class="page_navigation">
          <li class="page-item" (click)="navigatePage('prev')">
            <a class="page-link">
              <span class="fas fa-angle-left"></span>
            </a>
          </li>

          <ng-container *ngFor="let page of pages">
            <li
              class="page-item"
              [ngClass]="{
                disabled: page === '...',
                active: page === currentPage
              }"
              *ngIf="page !== '...'"
              (click)="navigateToPage(page)"
            >
              <a class="page-link">{{ page }}</a>
            </li>
            <li class="page-item disabled" *ngIf="page === '...'">
              <span class="page-link">...</span>
            </li>
          </ng-container>

          <li class="page-item" (click)="navigatePage('next')">
            <a class="page-link">
              <span class="fas fa-angle-right"></span>
            </a>
          </li>
        </ul>

        <p class="mt-3 mb-0 pagination_page_count text-center">
          {{ getDisplayRange() }} of
          {{ totalRecords }}
        </p>
      </div>
    </div> -->

  <!-- </div> -->

  <ng-template #noRecord>
    <div class="no-records-found">
      <p class="text-center">No records found.</p>
    </div>
  </ng-template>
</div>

<div *ngIf="showAddScoreModal" class="modal-overlay" (click)="closeAddScoreModal()">
  <div class="modal modal-card slide-up" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div>
        <h2>ADD SCORE</h2>
        <p class="modal-subtitle">{{ gameName || 'Game' }} · $1/pt</p>
      </div>
      <button (click)="closeAddScoreModal()">
        <fa-icon [icon]="cross"></fa-icon>
      </button>
    </div>

    <div class="wallet-toggle">
      <button type="button" [class.active]="selectedWallet === 'main'" (click)="selectedWallet = 'main'">
        MAIN WALLET
      </button>
      <button type="button" [class.active]="selectedWallet === 'bonus'" (click)="selectedWallet = 'bonus'">
        BONUS WALLET
      </button>
    </div>

    <div class="current-score-row">
      <span>Current Score</span>
      <span class="score-value">
        @if (isScoreLoading) {
        <span class="loading-dots">
          <span></span><span></span><span></span>
        </span>
        } @else {
        @if (currentScore === '' || currentScore === null || currentScore === undefined || currentScore === 'allow') {
        <fa-icon (click)="getScoreforAddding()" [icon]="refresh" class="refresh-icon"></fa-icon>
        } @else {
        <strong>{{ currentScore }}</strong>
        }
        }
        <fa-icon (click)="getScoreforAddding()" [icon]="refresh" class="refresh-icon"></fa-icon>
      </span>
    </div>

    <form [formGroup]="scoreForm" (ngSubmit)="IsScoreValid()" class="modal-form">
      <div class="form-row two-col">
        <div class="form-group">
          <label>SCORE AMOUNT</label>
          <input type="number" formControlName="score" [placeholder]="getPlaceholder()" />
          <div class="error-text">
            <ng-container *ngIf="scoreForm.get('score')?.hasError('required') && scoreForm.get('score')?.touched">Score is required.</ng-container>
            <ng-container *ngIf="scoreForm.get('score')?.hasError('min') && scoreForm.get('score')?.touched">Score must be at least 1.</ng-container>
            <ng-container *ngIf="scoreForm.get('score')?.hasError('notInteger') && scoreForm.get('score')?.touched">Score must be an integer.</ng-container>
          </div>
        </div>
        <div class="form-group total-cost">
          <label>TOTAL COST</label>
          <div class="cost-box">
            <i class="fas fa-dollar-sign"></i>
            <span>{{ scoreForm.get('score')?.value || '0' }}</span>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label>PROMO CODE (optional)</label>
        <input type="text" name="promoCode" [(ngModel)]="promoCode" placeholder="Enter promo code" />
      </div>

      <button type="submit" [disabled]="scoreForm.invalid" class="btn-gold-modal">
        ADD SCORE <i class="fas fa-arrow-right"></i>
      </button>
    </form>
  </div>
</div>

<!-- Confirm Payment Modal -->
<div *ngIf="showPaymentModal" class="modal-overlay" (click)="closePaymentModal()">
  <div class="modal modal-card slide-up" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div>
        <h2>ADD SCORE</h2>
        <p class="modal-subtitle">Confirm your purchase</p>
      </div>
      <button (click)="closePaymentModal()">
        <fa-icon [icon]="cross"></fa-icon>
      </button>
    </div>

    <form [formGroup]="paymentForm" (ngSubmit)="onPaymentSubmit()" class="modal-form">
      <div class="form-row two-col">
        <div class="form-group">
          <label>PURCHASE</label>
          <input type="text" formControlName="purchase" [(ngModel)]="addedScore" readonly />
        </div>
        <div class="form-group">
          <label>SCORE</label>
          <input type="text" formControlName="confirmScore" [(ngModel)]="roundedUpdatedGivenScore" readonly />
        </div>
      </div>

      <p class="offer-text" *ngIf="offerOnGame > 0">
        With the current offer, your score will be increased by {{ offerOnGame }}% for a purchase of ${{ addedScore }}, resulting in a total score of {{ updatedGivenScore }}.
      </p>

      <button type="submit" class="btn-gold-modal">
        CONFIRM <i class="fas fa-arrow-right"></i>
      </button>
    </form>
  </div>
</div>

<!-- Captcha Modal -->
<div *ngIf="showCaptchaModal"
  class="fixed inset-0 bg-black/80 flex items-center justify-center opacity-95 modal-overlay"
  (click)="closeCaptchaModal()">
  <div class="bg-[#2A2A2A] rounded-xl p-6 w-96 modal slide-up" (click)="$event.stopPropagation()">
    <div class="flex justify-between items-center mb-6">
      <h2 class="text-xl font-bold">CAPTCHA Security Check</h2>
      <button (click)="closeCaptchaModal()" class="text-gray-400 hover:text-white">
        X
      </button>
    </div>
    <form [formGroup]="captchaForm" (ngSubmit)="onCaptchaSubmit()">
      <div class="mb-4">
        <img [src]="captchaImage" alt="CAPTCHA" class="w-full mb-4 rounded-lg" />
        <input type="text" formControlName="captcha" placeholder="Write the text you see on the image"
          class="w-full bg-[#2a2438] border border-gray-700 rounded-lg px-4 py-2 text-white" />
      </div>
      <button type="submit" class="w-full back hover:bg-purple-700 py-2 rounded-lg">
        Submit
      </button>
    </form>
  </div>
</div>

<div *ngIf="showRedeemModal" (click)="closeRedeemModal()">
  <app-add-redeem [isFromRedeem]="false" [showModal]="showRedeemModal" (closeModal)="closeRedeemModal()"
    [selectedGame]="selectedGame" (isModalOpen)="showRedeemModal = $event"></app-add-redeem>
</div>

<!-- <ng-template> -->
@if (isCopied()) {
<div
  class="fixed bottom-[15%] left-1/2 transform -translate-x-1/2 bg-[#2C2C2C] text-white px-5 py-3 rounded-lg shadow-[0_4px_10px_rgba(0,0,0,0.2)] transition-opacity duration-300 z-50 flex items-center gap-3 border border-[#3A3A3A]">
  <fa-icon [icon]="faCheck" class="text-[#4CAF50] text-lg"></fa-icon>
  <span class="text-sm font-medium">Copied to clipboard</span>
</div>
}

<!-- </ng-template> -->